import { getJwtToken } from "@/lib/auth-client";
import { apiUrl } from "@/lib/api-config";

export async function getAuthHeaders(): Promise<HeadersInit> {
  const token = await getJwtToken();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
}

export async function apiFetch<T = unknown>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(apiUrl(path), {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...authHeaders,
      ...options.headers,
    },
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message =
      typeof data === "object" && data && "error" in data
        ? String((data as { error: string }).error)
        : `Request failed (${response.status})`;
    throw new Error(message);
  }

  return data as T;
}

export function getContractDownloadUrl(reviewId: string): Promise<{ downloadUrl: string }> {
  return apiFetch(`/api/contracts/${reviewId}/download-url`);
}

export async function presignContractUpload(fileName: string): Promise<{
  path: string;
  uploadUrl: string;
}> {
  return apiFetch("/api/uploads/presign", {
    method: "POST",
    body: JSON.stringify({ fileName }),
  });
}

export async function uploadToPresignedUrl(uploadUrl: string, file: File): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type || "application/pdf" },
  });
  if (!response.ok) {
    throw new Error("Failed to upload file to storage");
  }
}
